import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7 } from "styled-components";
import type { DownloadRow } from "~/features/downloads/adapter";
import { DownloadCellList } from "~/features/downloads/table/cells";
import { TableCell } from "~/features/downloads/table/table-cell";
import { TableTitle } from "~/features/downloads/table/table-title";
import { hasItems } from "~/features/app/utils";
import { getThemeStyle } from "~/features/ui/get-theme-style";
import { Wrap } from "~/features/ui/wrap";
type Props = {
  title: string;
  rows: DownloadRow[];
};

/**
 * Simple downloads table: a section title and a stacked list of rows, each a
 * heading plus its inline (full-width) cells. Covers the firmware, guides &
 * resources, developer tools, visualizer, and Velodyne families, which all
 * used identical markup in the legacy renderer (only the title differed).
 */
export function DirectTable(props: Props) {
  const {
    title,
    rows
  } = props;
  const themeStyle = getThemeStyle({
    mode: "light"
  });
  if (!hasItems(rows)) {
    return null;
  }
  return <_StyledSection $_css={[{
    "position": "relative",
    "zIndex": "10",
    "borderBottomWidth": "1px"
  }, themeStyle.background, themeStyle.border]}>
      <Wrap mode="light">
        <TableTitle title={title} />
        <_StyledDiv $_css2={[{
        "> :not([hidden]) ~ :not([hidden])": {
          "--tw-divide-y-reverse": "0",
          "borderTopWidth": "calc(1px * calc(1 - var(--tw-divide-y-reverse)))",
          "borderBottomWidth": "calc(1px * var(--tw-divide-y-reverse))"
        },
        "@media (min-width: 1024px)": {
          "> :not([hidden]) ~ :not([hidden])": {
            "--tw-divide-y-reverse": "0",
            "borderTopWidth": "calc(0px * calc(1 - var(--tw-divide-y-reverse)))",
            "borderBottomWidth": "calc(0px * var(--tw-divide-y-reverse))"
          }
        }
      }, themeStyle.border]}>
          {rows.map((row, idx) => <_StyledDiv2 key={idx}>
              <_StyledTableCell>
                <_StyledDiv3>{row.heading}</_StyledDiv3>
              </_StyledTableCell>
              <_StyledDiv4>
                <_StyledTableCell2>
                  <DownloadCellList cells={row.fullWidthCells} />
                </_StyledTableCell2>
              </_StyledDiv4>
            </_StyledDiv2>)}
        </_StyledDiv>
      </Wrap>
    </_StyledSection>;
}
var _StyledSection = /*#__PURE__*/_styled("section").withConfig({
  componentId: "sc-sf-18d4sml-0"
})`${p => p.$_css}`;
var _StyledDiv = _styled2("div").withConfig({
  componentId: "sc-sf-18d4sml-1"
})`${p => p.$_css2}`;
var _StyledDiv2 = _styled3("div").withConfig({
  componentId: "sc-sf-18d4sml-2"
})({
  "display": "flex",
  "flexDirection": "column",
  "@media (min-width: 1024px)": {
    "flexDirection": "row"
  }
});
var _StyledTableCell = _styled4(TableCell).withConfig({
  componentId: "sc-sf-18d4sml-3"
})({
  "@media (min-width: 1024px)": {
    "minWidth": "400px"
  }
});
var _StyledDiv3 = _styled5("div").withConfig({
  componentId: "sc-sf-18d4sml-4"
})({
  "flex": "1 1 0%"
});
var _StyledDiv4 = _styled6("div").withConfig({
  componentId: "sc-sf-18d4sml-5"
})({
  "width": "100%"
});
var _StyledTableCell2 = /*#__PURE__*/_styled7(TableCell).withConfig({
  displayName: "direct-table___StyledTableCell2",
  componentId: "sc-ilz3rx-0"
})({
  "whiteSpace": "normal"
});